import { useDispatch } from 'react-redux';
import { sendToastMessage } from '../actions/toast';
import { isValidMobileNumber } from '../utils/utils';
import IconToolTip from './IconToolTip';

export const WhatsappIcon = ({ mobile_number, size = 5, title = "Open WhatsApp" }) => {
    const dispatch = useDispatch();

    const onClick = () => {
        if (isValidMobileNumber(mobile_number)) {
            let whatsapp_url = `https://wa.me/91${mobile_number}`;
            window.open(whatsapp_url, '_blank');
        } else {
            dispatch(sendToastMessage({ status: 'danger', message: 'Invalid Mobile Number' }));
        }
    };

    return (
        <IconToolTip title={title}>
            <img onClick={onClick} src={process.env.PUBLIC_URL + "/img/whatsapp.png"} alt="" className='w-[1.7rem] -ml-1' />
        </IconToolTip>
    );
};
